export default __webpack_public_path__ + "static/media/07_Fenghsi.e3553cab.png";